import _ from "lodash";
import React, { useCallback, useContext, useEffect } from "react";
import { createUseStyles } from "react-jss";
import FullScreenLoader from "../../components/widgets/FullScreenLoader";
import jssVariables from "../../jss_setup";
import { StyleTypeContext } from "../../umbilical_tools";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { transfersErrorMsgs } from "../../errors";
import { transferSearchFormUpdate } from "../../actions/search/transfer_search";
import { useTransfersInitSearch } from "../../hooks/transfers";

function recreateFormData(decoded_data) {
  var data = {
    inboundPickupDate: decoded_data.inb,
    adults: decoded_data.adt,
    children: decoded_data.chd,
    children_ages: decoded_data.ages,
    tripMode: decoded_data.mode,
  };

  if (decoded_data.mode === "air_to_poi") {
    data = {
      ...data,
      origin: {
        latitude: decoded_data.orgn_lat,
        longitude: decoded_data.orgn_lng,
        iata: decoded_data.orgn_iata,
        name: decoded_data.orgn_nm,
        value: decoded_data.orgn_nm,
        label: decoded_data.orgn_nm,
        country_code: decoded_data.orgn_cd,
        location_type: decoded_data.orgn_loc_type,
      },
      destination: {
        name: decoded_data.dest_nm,
        value: decoded_data.dest_nm,
        label: decoded_data.dest_nm,
        country_code: decoded_data.dest_cd,
        location_type: decoded_data.dest_loc_type,
        computed_data: {
          geodata: {
            lat: decoded_data.dest_lat,
            lng: decoded_data.dest_lng,
          },
        },
      },
    };
  } else {
    data = {
      ...data,
      origin: {
        name: decoded_data.orgn_nm,
        label: decoded_data.orgn_nm,
        value: decoded_data.orgn_nm,
        country_code: decoded_data.orgn_cd,
        location_type: decoded_data.orgn_loc_type,
        computed_data: {
          geodata: {
            lat: decoded_data.orgn_lat,
            lng: decoded_data.orgn_lng,
          },
        },
      },
      destination: {
        latitude: decoded_data.dest_lat,
        longitude: decoded_data.dest_lng,
        iata: decoded_data.dest_iata,
        name: decoded_data.dest_nm,
        value: decoded_data.dest_nm,
        label: decoded_data.dest_nm,
        country_code: decoded_data.dest_cd,
        location_type: decoded_data.dest_loc_type,
      },
    };
  }
  return data;
}

function onError() {
  toast.warning(transfersErrorMsgs.searchForm.init_search, {
    duration: 5000,
  });
}

const styles = createUseStyles({
  DeepTransferSearch: (props) => ({
    position: "absolute",
    background: "#FAFAFA",
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    ..._.get(props, "customStyles.DeepTransferSearch", {}),
  }),
  [`@media ${jssVariables.media.smallscreen}`]: {},
});
const DeepTransferSearch = ({ encoded_data }) => {
  const dispatch = useDispatch();

  const [initSearch] = useTransfersInitSearch();

  const { type, brand, cStyler } = useContext(StyleTypeContext);
  const customStyles = cStyler({
    type,
    brand,
    objName: "DeepTransferSearch",
  });

  const classes = styles({ customStyles });

  var decoded_data = {};
  try {
    decoded_data = recreateFormData(JSON.parse(window.atob(encoded_data)));
  } catch (error) {
    onError();
  }

  const onFormUpdate = useCallback(
    ({ form }) => {
      dispatch(transferSearchFormUpdate({ form }));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!encoded_data) {
      onError();
    }
  }, []);

  async function onSearch() {
    onFormUpdate({
      form: {
        adults: decoded_data.adults,
        children: decoded_data.children,
        children_ages: decoded_data.children_ages,
      },
    });
    initSearch(decoded_data);
  }

  useEffect(() => {
    if (_.isEmpty(decoded_data)) {
      return;
    }
    onSearch();
  }, []);

  return (
    <div className={classes.DeepTransferSearch}>
      <FullScreenLoader />
    </div>
  );
};
DeepTransferSearch.propTypes = {
  encoded_data: PropTypes.string.isRequired,
};
export default DeepTransferSearch;
